import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

// This custom hook is to control entity of the dashboard page: jsonFormField, sectionJson.
// And CrudDrawer component state.
// Also childEntity state to control when creating child entity in the parent page ex: create area from building page.

const useStore = () => {
    // Drawer status state.
    const [drawerIsOpen, setDrawerIsOpen] = useState(false);
    const [copyCrud, setCopyCrud] = useState(false);
    // initial entity set to idle set make condition based on this initial value in
    // index.slice.js
    const [entity, setEntity] = useState('idle');
    // When create child entity we use this state and eventually clear state.
    const [childEntity, setChildEntity] = useState('');
    // Usually id of the building. but in the future we can use this for others. (supply...etc)
    const [parentId, setParentId] = useState('');
    // flash(snackbar status for all entity)
    const [crudSuccess, setCrudSuccess] = useState(false);
    const [crudError, setCrudError] = useState(null);
    // const [entityOverride, setEntityOverride] = useState(null);
    return {
        entity,
        setEntity: (entity) => setEntity(entity),
        childEntity,
        setChildEntity: (entity) => setChildEntity(entity),
        clearChildEntity: () => setChildEntity(''),
        parentId,
        setParentId: (id) => setParentId(id),
        drawerIsOpen,
        openDrawer: () => setDrawerIsOpen(true),
        closeDrawer: () => {
            setDrawerIsOpen(false);
            setCopyCrud(false);
            // setEntityOverride(null);
            setChildEntity(''); // set child entity to '' and automatically update drawer entity
            setParentId(''); // set parent id to ''
        },
        toggleOpenDrawer: () => setDrawerIsOpen((prev) => !prev),
        crudSuccess,
        setCrudSuccess: (status) => setCrudSuccess(status),
        crudError,
        setCrudError: (message) => setCrudError(message),
        // entityOverride,
        setEntityOverride: (overrideEntity) => setEntity(overrideEntity),
        copyCrud,
        setCopyCrud: (bool) => setCopyCrud(bool),
    };
};

// can be null. set this to get extra support by intellisense
const DrawerContext = createContext({
    entity: '',
    setEntity: () => {},
    entityOverride: '',
    setEntityOverride: () => {},
    childEntity: '',
    setChildEntity: () => {},
    clearChildEntity: () => {},
    parentId: '',
    setParentId: () => {},
    drawerIsOpen: false,
    openDrawer: () => {},
    closeDrawer: () => {},
    toggleOpenDrawer: () => {},
    crudSuccess: false,
    setCrudSuccess: () => {},
    crudError: null,
    setCrudError: () => {},
    copyCrud: false,
    setCopyCrud: () => {},
});

export const DrawerContextProvider = ({ children }) => (
    <DrawerContext.Provider value={useStore()}>
        {children}
    </DrawerContext.Provider>
);

DrawerContextProvider.propTypes = {
    children: PropTypes.node,
};

// Facade pattern to facilitate use of contexts (custom facade hooks)

// based on entity set use redux actions and set formfield and sections
export const useEntity = () => useContext(DrawerContext).entity;
export const useSetEntity = () => useContext(DrawerContext).setEntity;
// based on entity set use redux actions and set formfield and sections
// export const useEntityOverride = () => useContext(DrawerContext).entityOverride;
// export const useSetEntityOverride = () => useContext(DrawerContext).setEntityOverride;
// In case of using CrudDrawer to create child entity use entity from this. childEntity.
export const useChildEntity = () => useContext(DrawerContext).childEntity;
export const useSetChildEntity = () => useContext(DrawerContext).setChildEntity;
// Use this hook to send requet.body.__parent and in the api will handle saving in parent.
export const useParentId = () => useContext(DrawerContext).parentId;
export const useSetParentId = () => useContext(DrawerContext).setParentId;

// Drawer status contexts hooks
export const useDrawerIsOpen = () => useContext(DrawerContext).drawerIsOpen;
export const useOpenDrawer = () => useContext(DrawerContext).openDrawer;
export const useCloseDrawer = () => useContext(DrawerContext).closeDrawer;
export const useToggleOpenDrawer = () =>
    useContext(DrawerContext).toggleOpenDrawer;

// this hook to use easily
export const useDrawerContext = () => useContext(DrawerContext);

// Planning specific drawer state

// Crud Status for flash message at the top
// export const useCrudSuccess = () => useContext(DrawerContext).crudSuccess;
// export const useSetCrudSuccess = () => useContext(DrawerContext).setCrudSuccess;
// export const useCrudError = () => useContext(DrawerContext).crudError;
// export const useSetCrudError = () => useContext(DrawerContext).setCrudError;
